import $axios from "../api/accessor";
import { $api } from "../api/api";

export const DeliveryBranchesService = {
  getDeliveryBranches: async (params?: Record<string, any>) => {
    try {
      const cleanParams: Record<string, any> = {};
      if (params) {
        Object.entries(params).forEach(([key, value]) => {
          if (value !== undefined && value !== null && value !== "") {
            cleanParams[key] = value;
          }
        });
      }
      const response = await $axios.get($api("delivery_branches", cleanParams));
      return { data: response?.data, status: response?.status };
    } catch (error: any) {
      return { data: null, status: error?.response?.status || 500, error };
    }
  },

  getDeliveryBranchesCities: async (params?: Record<string, any>) => {
    try {
      const cleanParams: Record<string, any> = {};
      if (params) {
        Object.entries(params).forEach(([key, value]) => {
          if (value !== undefined && value !== null && value !== "") {
            cleanParams[key] = value;
          }
        });
      }
      const response = await $axios.get($api("delivery_branches_cities", cleanParams));
      return { data: response?.data, status: response?.status };
    } catch (error: any) {
      return { data: null, status: error?.response?.status || 500, error };
    }
  },
};
